import { render, staticRenderFns } from "./MarginCalculatedNew.vue?vue&type=template&id=802ea354&scoped=true"
import script from "./MarginCalculatedNew.vue?vue&type=script&lang=js"
export * from "./MarginCalculatedNew.vue?vue&type=script&lang=js"
import style0 from "./MarginCalculatedNew.vue?vue&type=style&index=0&id=802ea354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802ea354",
  null
  
)

export default component.exports